var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUploadAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.334,13.564L22.12,3.778c.997-.997,2.763-.997,3.76,0l9.786,9.786c1.038,1.038,1.038,2.721,0,3.76-.518.52-1.199.779-1.88.779s-1.361-.259-1.88-.779l-5.247-5.247v19.05c0,1.468-1.191,2.659-2.659,2.659s-2.659-1.191-2.659-2.659V12.076l-5.247,5.247c-1.037,1.038-2.721,1.038-3.76,0-1.038-1.038-1.038-2.721,0-3.76ZM46,35.278c0,5.344-4.349,9.692-9.692,9.692H11.692c-5.344,0-9.692-4.349-9.692-9.692v-4.96c0-1.468,1.191-2.659,2.659-2.659s2.659,1.191,2.659,2.659v4.96c0,2.412,1.962,4.374,4.374,4.374h24.615c2.412,0,4.374-1.962,4.374-4.374v-4.96c0-1.468,1.191-2.659,2.659-2.659s2.659,1.191,2.659,2.659v4.96h.001Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadAlt);
export default __webpack_public_path__ + "static/media/icon-upload-alt.0aeeca7627156ac617782230122d38eb.svg";
export { ForwardRef as ReactComponent };